function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H64V64H0z",
  transform: "translate(-1)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#73738B",
  fillOpacity: 0.3,
  fillRule: "nonzero",
  d: "M49 57H7V15h27V9H7c-3.3 0-6 2.7-6 6v42c0 3.3 2.7 6 6 6h42c3.3 0 6-2.7 6-6V30h-6v27zm-23.37-9.51l-5.88-7.08L11.5 51h33L33.88 36.87l-8.25 10.62zM55 9V0h-6v9h-9c.03.03 0 6 0 6h9v8.97c.03.03 6 0 6 0V15h9V9h-9z",
  transform: "translate(-1)"
}));

var SvgIcoUploadImage = function SvgIcoUploadImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoUploadImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-upload-image.fcc3836c.svg";
export { ForwardRef as ReactComponent };